import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslatePlural } from '@change-corgi/core-react/i18n';

import { usePetitionActionsPageData, usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';

export const Header: React.FC = () => {
	const {
		data: {
			petition: {
				ask,
				signatureState: { signatureCount },
			},
		},
	} = usePetitionActionsPageData();
	const [{ shareSupporterVoiceSuccess }] = usePetitionActionsPageState();

	if (shareSupporterVoiceSuccess) return null;

	return (
		<div
			className="mb-5 rounded-md p-4"
			// FIXME: Temporarily using the code, change with the token
			style={{ background: 'rgba(64, 58, 73, 0.9)' }}
		>
			<Text as="h1" variant="heading" size="large" fontWeight="bold" className="mb-3 line-clamp-2 text-white">
				{ask}
			</Text>
			<Text data-testid="campaign-supporters-count" variant="body" size="medium" className="text-white">
				<TranslatePlural
					value="corgi.petition_actions.heading.supporters"
					count={signatureCount.displayed}
					replacements={{ signatureCount: signatureCount.displayedLocalized }}
				/>
			</Text>
		</div>
	);
};
